import { api } from '@api'
import { Trailer } from '@types'

interface CreateTrailerResponse {
  result: Trailer
}

const createTrailer = async (payload: Trailer) => {
  const response = await api.post<CreateTrailerResponse>('/trailers', { trailer: payload })

  return response.data.result
}

export const TrailersApi = { createTrailer }
